import t from '@jetshop/intl';
import React from 'react';
import styled, { css } from 'react-emotion';
import Image from '@jetshop/ui/Image';
import { Shortcodes } from '@jetshop/flight-shortcodes';

const Card = styled('div')`
  width: 100%;
  padding: 15px 15px;
  background: white;
  position: relative;

  ul {
    display: flex;

    li:first-child {
      margin-right: 15px;
    }
  }
`;

const Title = styled('p')`
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
`;

const Review = styled('p')`
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  font-style: italic;
`;

const ImageWrapper = styled('div')`
  width: 50px;
  height: 50px;
  border-radius: 100%;
  overflow: hidden;
`;

function addQuotationMarks(children) {
  const trimmed = children.trim();
  return '"' + trimmed + '"';
}

const Citat = ({ image, title, children }) => {
  return (
    <Card>
      <ul>
        <li>
          <ImageWrapper>
            <Image
              cover={true}
              src={image}
              sizes={[1 / 4]}
              aspect={'1:1'}
              alt={image}
            />
          </ImageWrapper>
        </li>
        <li>
          <Title>{title}</Title>
          <Review>{addQuotationMarks(children)} </Review>
        </li>
      </ul>
    </Card>
  );
};

const ProductReviewCard = ({ productReview = null }) => {
  return (
    <Shortcodes
      content={productReview.stringValue}
      components={{
        Citat: Citat
      }}
    />
  );
};

export default ProductReviewCard;
